module.exports = __webpack_public_path__ + "img/google_maps.c181ef10.png";